module.exports = __webpack_public_path__ + "static/media/phone.b2572be0.png";